import styled from "styled-components";

export const Inner = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;
